export enum PowerSupplyErrors {
  DELETE = 'powerSupplies/deletePowerSupply',
  CREATE = 'powerSupplies/createPowerSupply',
  EDIT = 'powerSupplies/editPowerSupply',
  GET = 'powerSupplies/getPowerSupply'
}
